import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import axios from "axios";

import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  Heading,
  VStack,
  Divider,
  Image,
  Flex,
  Text,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { BASE_URL } from "../api";

const schema = yup.object({
  email: yup.string().email("Invalid email").required("Email is required"),
});

const ForgotPass = () => {
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
  });

  const onSubmit = async (data) => {
    console.log(data);

    try {
      const response = await axios.post(
        `${BASE_URL}/auth/forgot-password`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response.data);
      if (response.status === 201) {
        reset();
      } else {
        console.error("Error verifying email");
      }
    } catch (error) {
      console.error("Error verifying email", error);
    }
    // navigate('/');
  };

  return (
    <>
      <Flex w="100%">
        <Box w="53%" bg="blue.600" h={"100vh"}>
          <Box h="33%" w="100%">
            <Image justifySelf={"start"} w={"60%"} src={"/assets/1.png"} />
          </Box>
          <Box w="100%" alignContent="center" h="34%" justifySelf="center">
            <Text
              textAlign="center"
              textColor="white"
              fontSize="4xl"
              fontWeight="semibold"
            >
              Forgot Your Password?
            </Text>
            <Text textAlign="center" textColor="white" fontSize="lg">
              Enter Your Email to get a Verification Link
            </Text>
          </Box>
          <Box alignContent="end" h="33%" w="100%" justifySelf="center">
            <Image justifySelf={"center"} w={"80%"} src={"/assets/2.png"} />
          </Box>
        </Box>
        <Box w={"47%"} h={"100vh"} alignContent={"center"}>
          <Box
            py={3}
            px={{ base: 4, md: 8 }}
            rounded={"xl"}
            align={"center"}
            h={"fit-content"}
            w={{
              base: "90%",
              md: "80%",
              lg: "70%",
              xl: "50%",
              xxl: "40%",
            }}
            justifySelf={"center"}
            color={"#008DD1"}
            // bg={'#F7F9FF'}
          >
            <Image
              justifySelf={"center"}
              w={"100px"}
              src={"/assets/digital-bikana.png"}
            />
            <Heading fontSize={"2xl"} textAlign={"center"}>
              Enter Email!
            </Heading>
            <Divider
              mt={"10px"}
              justifySelf={"center"}
              borderColor={"#008DD1"}
              borderWidth={"0.15rem"}
              opacity={100}
              rounded={"full"}
              width="15%"
            />
            <form onSubmit={handleSubmit(onSubmit)}>
              <VStack spacing={4}>
                <FormControl isInvalid={!!errors.email}>
                  <FormLabel>Email</FormLabel>
                  <Input
                    {...register("email")}
                    rounded={"full"}
                    placeholder="Enter email"
                    autoComplete="email"
                    _hover={{ borderColor: "gray.400" }}
                    border={"1px"}
                    borderColor={"gray.300"}
                    _placeholder={{ color: "gray.500" }}
                  />
                  <FormErrorMessage>{errors.email?.message}</FormErrorMessage>
                </FormControl>
                <Button
                  // mt={{ base: 4, md: 4, lg: 6, xl: 8 }}
                  rounded={"full"}
                  type="submit"
                  bg={"#008DD1"}
                  w="100%"
                  _hover={{ opacity: "0.8" }}
                  color={"white"}
                >
                  Verify Email
                </Button>
                <Text
                  p={0}
                  fontWeight={"semibold"}
                  bg={"transparent"}
                  w="100%"
                  textAlign="end"
                  _hover={{ color: "blue.600", cursor: "pointer" }}
                  color={"blue.400"}
                  onClick={() => navigate("/login")}
                >
                  Go Back
                </Text>
              </VStack>
            </form>
          </Box>
        </Box>
      </Flex>
    </>
  );
};

export default ForgotPass;
